// src/pages/ChatPage.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  IconButton,
  TextField,
  Paper,
  Button,
} from '@mui/material';
import DashboardLayout from './DashboardLayout';
import axios from "axios";
import PatientInfo from './PatientInfo';
import {
 InputAdornment,
} from "@mui/material";
import { ReactComponent as MicIcon } from "../assets/Group 18331 (1).svg";
import { ReactComponent as SiriIcon } from "../assets/Siri AnimationIcon.svg";
import { ReactComponent as SendIcon } from "../assets/submit.svg";
import { ReactComponent as HomeIcon } from "../assets/home.svg";
import { styled, width } from "@mui/system";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import parse from "html-react-parser"; // To render HTML responses
import PatientListDialog from "../popup/PatientListDialog";
import { cleanHTML } from "../lib/helper";
import { useLocation, useNavigate } from "react-router-dom";
import FloatingMenu from "../common/FloatingMenu";
import { getUserLocalData } from "../lib/helper";

const MessagesContainer = styled(Box)({
  flex: 1,
  padding: "10px 24px 10px 24px",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "100%",
  height:'calc(100vh - 190px)',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '6px',
  },

  /* For Firefox */
  scrollbarWidth: 'thin',             // Makes scrollbar thinner
  scrollbarColor: 'rgba(255,255,255,0.2) transparent',
});
const MessageBubble = styled(Paper)(({ isUser }) => ({
  padding: "10px 15px",
  maxWidth: "70%",
  alignSelf: isUser ? "flex-end" : "flex-start",
  backgroundColor: isUser ? "#1976D2" : "#E3F2FD",
  color: isUser ? "#fff" : "#000",
  borderRadius: "10px",
}));

const Chat2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const chatsMessages = location?.state?.chatsMessages || [];
  const token = JSON.parse(localStorage.getItem("access_token"));
  const patient_id = localStorage.getItem("patient_id");
  const session_id = localStorage.getItem("session_id");
  const [query, setQuery] = useState("");
  const [messages, setMessages] = useState(chatsMessages);
  const [patientList, setPatientList] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const { user_name } = getUserLocalData();


  // Ensure patient_id and session_id are valid (not "undefined" or null)
  const validPatientId =
    patient_id && patient_id !== "undefined" ? patient_id : null;
  const validSessionId =
    session_id && session_id !== "undefined" ? session_id : null;
  const conversationId = location?.state?.conversationId;

  const [isFetchingData, setIsFetchingData] = useState(
    conversationId ? true : false
  );

  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const [isUserAtBottom, setIsUserAtBottom] = useState(true); // Track user's scroll position

  // Detect if the user is at the bottom or scrolling up
  const handleScroll = () => {
    if (!messagesContainerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } =
      messagesContainerRef.current;

    // If user is at the bottom (or very close), set flag to true
    setIsUserAtBottom(scrollHeight - scrollTop <= clientHeight + 10);
  };

  useEffect(() => {
    const container = messagesContainerRef.current;
    if (!container) return;

    // Attach scroll event listener
    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isUserAtBottom && messagesContainerRef.current) {
      // Instantly jump to the bottom (no animation)
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [messages]); // Runs when messages update

  useEffect(() => {
    conversationId && fetchRecentChat();
    if (!conversationId) {
      setMessages([]);
    }
  }, [conversationId]);

  const fetchRecentChat = async (e) => {
    try {
      setIsFetchingData(true);
      const response = await axios.get(
        `${process.env.REACT_APP_QUERY_URL}/conversation/${conversationId}`
      );
      setIsFetchingData(false);
      if (response?.data) {
        const filteredMessages = response.data?.filter(
          (msg) => msg.role !== "system" && msg.role !== "tool"
        );
        setMessages(filteredMessages);
        // setPatientList(response?.data?.patients);
        setPatientList(response?.data?.patient);
      }
    } catch (error) {
      setIsFetchingData(false);
      console.error("Error:", error?.response?.data?.detail);
      setMessages((prev) => [
        ...prev,
        { role: "bot", content: error?.response?.data?.detail },
      ]);
    }
  };

  const sendMessage = async (e, customMessage = undefined) => {
    const checkEmptyMessageStatus = customMessage ? false : !query.trim();
    // && !transcript.trim();
    if (checkEmptyMessageStatus) return; // Prevent empty submissions

    const userInput = customMessage
      ? customMessage
      : // : transcript.trim()
      // ? transcript
      query;
    setQuery(""); // Clear the text input
    // resetTranscript(); // Reset voice input
    setMessages([...messages, { role: "user", content: userInput }]);
    setLoading(true); // Start loading
    try {
      if (!validPatientId) {
        const response = await axios.post(
          `${process.env.REACT_APP_QUERY_URL}?query=${userInput}&access_token=${token}&identity=CLARA`
        );

        if (response?.data) {
          // setPatientList(response?.data?.patients);
          setPatientList(response?.data?.patient);
          setOpen(true);

          setResponseMessage(response?.data?.response);
        }
      } else {
        const patient_id_formatted = patient_id.replace(/^"|"$/g, "");
        let url = `${process.env.REACT_APP_QUERY_URL}?query=${userInput}&access_token=${token}&session_id=${validSessionId}&patient_id=${patient_id_formatted}&identity=CLARA`;
        if (user_name) {
          url += `&practitioner=${user_name}`;
        }
        const response = await axios.post(url);
        if (response?.data) {
          const filteredMessages = response.data?.conversation.filter(
            (msg) => msg.role !== "system" && msg.role !== "tool"
          );
          if (!validSessionId && response?.data?.session_id) {
            localStorage.setItem("session_id", response.data.session_id);
          }
          setMessages([...messages, ...filteredMessages]);
          // setPatientList(response?.data?.patients);
          setPatientList(response?.data?.patient);
        }
      }
    } catch (error) {
      console.error("Error:", error?.response?.data?.detail);
      setMessages((prev) => [
        ...prev,
        { role: "bot", content: error?.response?.data?.detail },
      ]);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const clearMessages = () => {
    setMessages([]); // Reset chat messages
  };

  const onMicClick = () => {
    navigate("/voice", { state: { isFromChatScreen: true, messages } });
    // SpeechRecognition.startListening({ continuous: false })
  };
  return (
    <>
      <DashboardLayout>
        {/* Container for the chat interface */}
        <Box display={'flex'} justifyContent={'flex-start'} flexDirection={'row'} sx={{ width: '100%', height: '100%' }}>
          <Box sx={{ mt: 2 }}> <PatientInfo onTipClick={(tip) => setQuery(tip)} /></Box>
          <Box sx={{ width: '100%', height: '100vh', }}>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 'calc(100vh - 190px)',
                textAlign: 'center',
              }}
            >
              {!messages?.length && !isFetchingData ? (
                <>
                  <Box >
                    <Typography variant="h6" color="white" sx={{ mb: 1 }}>
                      Speaking to <strong>CLARA</strong>
                    </Typography>
                    <Typography variant="body1" color="#b0b0b0" sx={{ mb: 4 }}>
                      Go ahead, I am attentive and ready to listen.
                    </Typography>
                    <Box
                      sx={{
                      }}
                    ><SiriIcon /></Box>
                  </Box>
                </>) : null}
              {/* Speaking Title */}

              {patient_id && !isFetchingData && (
                <Box sx={{position:'fixed', margin:'0 0 0 48px', width:'-webkit-fill-available'}}>
                <MessagesContainer
                  className="msg-container"
                  ref={messagesContainerRef}
                >
                  {messages.map((msg, index) => (
                    <MessageBubble
                      className="chat"
                      key={index}
                      isUser={msg.role === "user"}
                    >
                      {cleanHTML(msg?.content)}
                    </MessageBubble>
                  ))}
                  {loading && (
                    <MessageBubble isUser={false}>Typing...</MessageBubble>
                  )}
                  <div ref={messagesEndRef} />
                </MessagesContainer>
                </Box>
              )}
              {/* Listening Orb */}
              {/* <Box
              /> */}
              {/* Chat Input */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  maxWidth: '700px',
                  px: 2,
                  py: 1,
                  borderRadius: '30px',
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  position: 'fixed',
                  bottom: '1rem',
                }}
                onSubmit={(e) => {
                  e.preventDefault();
                  sendMessage();
                }}
              >

                <TextField
                  variant="standard"
                  placeholder="Send a message"
                  InputProps={{
                    disableUnderline: true,
                    sx: { color: '#fff', },
                    startAdornment: (
                      <FloatingMenu
                        className="floating-menu"
                        onClick={sendMessage}
                      />
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        {" "}
                        <IconButton
                          onClick={sendMessage}
                          sx={{
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                        >
                          <SendIcon type="submit" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  sx={{ width: '100%' }}
                />

                <Box className="mic-icon" sx={{ cursor: 'pointer' }}>
                  <MicIcon width={64} height={64} onClick={onMicClick} />
                </Box>
              </Paper>
            </Box>
          </Box>
        </Box>
      </DashboardLayout>
      {open && (
        <Box sx={{
          position: 'absolute',
          left: '200px',
        borderRadius: '14px',
          border:'1px solid rgba(234, 236, 240, 0.06)'
        }}>
          <PatientListDialog
            open={open}
            setOpen={setOpen}
            data={patientList}
            message={responseMessage}
            clearMessages={clearMessages}
          />
        </Box>

      )}
    </>

  );
};

export default Chat2;
